import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useSubNavPlacement } from './useWideViewport';

// Module-level shared state (singleton)
const sidebarOpen = ref(false); // overlay drawer (portrait / phone)
const desktopSidebarOpen = ref(true); // the docked column's expanded state (landscape/desktop only)
const isRoomsActive = ref(false);

/**
 * Is the rooms rail DOCKED beside the content — i.e. is the shell showing its
 * own navigation as a left column? Never a width test: at 800x1333 portrait
 * `innerWidth >= 768` was true and this was `true` on a tablet that keeps its
 * section navigation in the bottom bar, which is exactly how the rooms list
 * ended up as a 224px column beside that bar (card t_d9971280). The decision
 * lives in `useWideViewport` with the shell's, so the two cannot disagree.
 */
const isDockedColumn = computed(() => useSubNavPlacement().value === 'column');

export function useRoomsNav() {
  const route = useRoute();

  const normalizedPath = computed(() => route.path.replace(/^\/h\/[^/]+/, ''));

  const currentPageLabel = computed(() => {
    if (normalizedPath.value === '/rooms/overview' || normalizedPath.value === '/rooms') {
      return 'Rooms';
    }
    return 'Room';
  });

  function toggleSidebar() {
    if (isDockedColumn.value) {
      desktopSidebarOpen.value = !desktopSidebarOpen.value;
    } else {
      sidebarOpen.value = !sidebarOpen.value;
    }
  }

  function closeSidebar() {
    sidebarOpen.value = false;
  }

  function setRoomsActive(active: boolean) {
    isRoomsActive.value = active;
    if (!active) sidebarOpen.value = false;
  }

  return {
    sidebarOpen,
    desktopSidebarOpen,
    isDockedColumn,
    isRoomsActive,
    currentPageLabel,
    toggleSidebar,
    closeSidebar,
    setRoomsActive,
  };
}
